export default "__VITE_ASSET__C3hm8ZBK__"